var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-md-flex mb-3"},[_c('div',{staticClass:"col-md-6 col-sm-12 col-xs-12 p-0"},[_c('Valoracion',{attrs:{"base_id":_vm.base.id,"valoracion":_vm.base.valoracion},on:{"getBase":function($event){return _vm.$emit('getBase')}}})],1),_c('div',{staticClass:"col-md-6 col-sm-12 col-xs-12 p-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }